function hiddenShowLegend(chart, event, dadosGrafico) {
    var legenda = event.dataItem;
    if (undefined !== legenda.hidden && legenda.hidden) {
        filtraGrafico(false, legenda, chart, dadosGrafico);
        legenda.hidden = false;
    } else {
        filtraGrafico(true, legenda, chart, dadosGrafico);
        legenda.hidden = true;
    }
    chart.legend.validateNow();

}
function filtraGrafico(status, legenda, chart, dadosGrafico) {
    var filtrado = [];
    // Quando estiver escondendo a legenda é verdadeiro
    if(status) {
        chart.chartData.forEach(function (item) {
           if(legenda.groupId != item.dataContext.groupId) {
               filtrado.push(item.dataContext);
           }
        });
    } else {
        dadosGrafico.forEach(function (item) {
            if(legenda.groupId == item.groupId) {
                filtrado.push(item);
            }
        });

        chart.dataProvider.forEach(function (item) {
            filtrado.push(item);
        });
    }
    chart.dataProvider = filtrado;
    chart.validateData();
}
function init(chart, event, dadosGrafico) {
   hiddenShowLegend(chart, event, dadosGrafico);
}
export default {
    init
}


// WEBPACK FOOTER //
// ./resources/assets/layout-novo/js/modulo/custom-legend-amcharts.js